export default __webpack_public_path__ + "static/media/ny-yogi.6737f78c.jpg";